// ACTA_AGENT_DOCUMENT_SHARE_ACTION_V1

import {
  documents as documentsApi,
  prospects as prospectsApi,
} from "@/api";

import {
  bestAgentMatches,
  rankAgentMatches,
  searchableDocument,
  searchableProspect,
} from "@/agent/entityResolver";

export const MAX_AGENT_ATTACHMENT_BYTES =
  250 * 1024 * 1024;

export const AGENT_DOCUMENT_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "png",
  "jpg",
  "jpeg",
  "webp",
  "html",
  "htm",
];

export const AGENT_ATTACHMENT_ACCEPT =
  AGENT_DOCUMENT_EXTENSIONS
    .map(
      (extension) =>
        `.${extension}`
    )
    .join(",");

function fileExtension(
  name = ""
) {
  const value =
    String(name).trim();

  const lastDot =
    value.lastIndexOf(".");

  if (
    lastDot < 0
    || lastDot ===
      value.length - 1
  ) {
    return "";
  }

  return value
    .slice(lastDot + 1)
    .toLowerCase();
}

export function validateAgentAttachment(
  file
) {
  if (!file) {
    return null;
  }

  if (
    !AGENT_DOCUMENT_EXTENSIONS
      .includes(
        fileExtension(file.name)
      )
  ) {
    return (
      "Type de fichier non autorisé."
    );
  }

  if (
    file.size >
      MAX_AGENT_ATTACHMENT_BYTES
  ) {
    return (
      "Fichier trop volumineux. "
      + "Taille maximale autorisée : 250 Mo."
    );
  }

  return null;
}

export async function prepareDocumentShare({
  command,
  attachedFile = null,
}) {
  const prospects =
    await prospectsApi.list();

  const contactMatches =
    bestAgentMatches(
      rankAgentMatches(
        Array.isArray(prospects)
          ? prospects
          : [],
        command,
        searchableProspect
      )
    );

  let documentMatches = [];

  if (attachedFile) {
    documentMatches = [
      {
        id:
          "__agent_attachment__",
        name:
          attachedFile.name,
        size:
          attachedFile.size,
        type: "document",
        isAgentAttachment: true,
      },
    ];
  } else {
    const documents =
      await documentsApi.list();

    documentMatches =
      bestAgentMatches(
        rankAgentMatches(
          Array.isArray(
            documents
          )
            ? documents
            : [],
          command,
          searchableDocument
        )
      );
  }

  return {
    contactMatches,
    documentMatches,
  };
}

export async function materializeAgentDocument({
  selectedDocument,
  attachedFile,
}) {
  if (
    attachedFile
    && selectedDocument
      ?.isAgentAttachment
  ) {
    return documentsApi.upload(
      attachedFile
    );
  }

  return selectedDocument;
}
